import { driver } from 'driver.js';
import { markTutorialAsComplete } from '../hooks/useTutorials.api';
import { createRelaunchPortalToursStep } from '../hooks/useTutorials.helpers';
import { TTutorialName } from '../hooks/useTutorials.types';

export const triggerRelaunchStep = ({
  introducerId,
  tutorial,
}: {
  introducerId: string | null;
  tutorial: TTutorialName;
}) => {
  const onClose = () => {
    tour.destroy();
    markTutorialAsComplete({
      introducerId,
      tutorial,
    });
  };

  const tour = driver({
    showButtons: ['next', 'close'],
    popoverClass: 'driver-popover-custom',
    steps: [createRelaunchPortalToursStep(onClose)],
    onCloseClick: onClose,
    overlayClickBehavior: undefined,
  });

  tour.drive();
};
